import { Routes } from '@angular/router';
import { isAdminGuard, isAuthenticatedGuard } from './app.guards';

export const appRoutes: Routes = [
    {
        path: 'login',
        loadComponent: () =>
            import('./login/login-page/login-page').then((m) => m.LoginPage),
    },
    {
		path: 'nominations',
        data: { admin: false },
        canActivate: [isAuthenticatedGuard],
		loadComponent: () =>
			import('./list-nominations/list-nominations-widget/list-nominations-widget').then((module) => module.ListNominationsWidget),
	},
    {
		path: 'nominations/admin',
        data: { admin: true },
        canActivate: [isAuthenticatedGuard, isAdminGuard],
		loadComponent: () =>
			import('./list-nominations/list-nominations-widget/list-nominations-widget').then((module) => module.ListNominationsWidget),
	},
    {
        path: '**',
        redirectTo: 'nominations/admin',
    },
];
